// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1v1SD","infoBtn":"quickbooks_infoBtn__2uoQf","formBox":"quickbooks_formBox__3_VK-","formFooter":"quickbooks_formFooter__1DxuH"};